import {getName, getPluginName} from '@packages/systems/wfdl-Qualified';
import {singleMemo, weakMemo} from '@packages/utilities/memo';
import * as StyleVariables from '@packages/systems/core/utils/StyleVariables';

/**
 * Given map of all variables in the project creates map for variables that were imported from specific library (identified by pluginName).
 * Key is the origin id of the variable as was in the library and value is the id of the variable in the project.
 */
export const getLibrariesVariablesOriginIdMap = weakMemo(
  (variables: StyleVariables.VariableMap) =>
    singleMemo((pluginName: string) => {
      return variables.reduce(
        (acc, variable) => {
          if (
            variable.origin &&
            getPluginName(variable.origin) === pluginName
          ) {
            acc[getName(variable.origin)] = variable.id;
          }
          return acc;
        },
        {} as Record<string, string>
      );
    })
);
